import { GlobalStyles, useTheme } from '@mui/material'

export const CkeditorZIndexWrapper = () => {
	const theme = useTheme()
	const z = (theme.zIndex?.modal ?? 1500) + 1 // Above any modal

	return <GlobalStyles styles={{ body: { ['--ck-z-panel' as any]: z } }} />
}

